import React, { memo, useEffect } from 'react';
import { StyleSheet, Text } from 'react-native';
import { ActionButton, DataTable } from '../../components';
import { __WEB__, FONT } from '../../../constants/styles';
import moment from 'moment';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { fetchCanceledAppointments } from './slice';
import { deleteEvent } from '../../calendar/actions';

import * as ASSETS from '../../../constants/assets';

function dateAndTimeForDate(d) {
  const mom = moment(d);
  return {
    dateStr: mom.format('M/DD/YYYY'),
    timeStr: mom.format('HH:mm'),
  };
}

const Actions = memo(function (props) {
  function handleAcceptPress() {
    props.handleCancel(props.a.item);
  }
  return <ActionButton source={ASSETS.approve} disabled={false} onPress={handleAcceptPress} />;
});

const CancelledAppointments = function CancelledAppointments(props) {
  useEffect(() => {
    if (props.wsConnected && props.employer?.employerId && props.eventType) {
      props.actions.fetchCanceledAppointments({
        employerId: props.employer?.employerId,
        eventType: props.eventType,
      });
    }
  }, [props.wsConnected, props.employer, props.eventType]);

  const cancelled = props.canceledAppts || [];
  const numCancellations = props.canceledAppts?.length;
  const mostRecentEventId =
    numCancellations && props.canceledAppts?.[numCancellations - 1]?.eventId;

  useEffect(
    function () {
      if (mostRecentEventId) {
        const appt = props.canceledAppts?.[numCancellations - 1];
        const dateAndTimeStrs = dateAndTimeForDate(appt.startDate);
        const notificationTextNode = (
          <Text>
            {appt.patientName} <Text style={FONT.regular}> canceled their </Text>
            {appt.eventName}
            <Text style={FONT.regular}> for </Text>
            {dateAndTimeStrs.dateStr} at {dateAndTimeStrs.timeStr}
          </Text>
        );
        props.onCancelledApptNotification?.(notificationTextNode, appt.eventName);
      } else {
        props.onCancelledApptNotification?.(null);
      }
    },
    [mostRecentEventId]
  );

  const columnData = [
    {
      headerLabel: 'NAME',
      style: __WEB__ ? { flexGrow: 0.6, width: 130 } : { flex: 1 },
      dataAccessor: 'patientName',
    },
    {
      headerLabel: 'APPOINTMENT DATE',
      style: __WEB__ ? { flexGrow: 0.1, width: 110 } : { flex: 1 },
      dataAccessor: 'appointmentDate',
    },
    {
      headerLabel: 'APPOINTMENT TIME',
      style: __WEB__ ? { flexGrow: 0.1, width: 110 } : { flex: 1 },
      dataAccessor: 'appointmentTime',
    },
    {
      headerLabel: 'ACTIONS',
      style: __WEB__ ? { flexGrow: 0.1, width: 150 } : { flex: 1 },
      dataAccessor: (a) => <Actions a={a} handleCancel={props.onCancelPress} />,
    },
  ];
  const rowData = cancelled.map((a) => {
    const dateAndTimeStrs = dateAndTimeForDate(a.startDate);
    return {
      ...a,
      item: a,
      key: a.eventId,
      appointmentDate: dateAndTimeStrs.dateStr,
      appointmentTime: dateAndTimeStrs.timeStr,
    };
  });
  return <DataTable columns={columnData} data={rowData} />;
};

const styles = StyleSheet.create({});

function mapStateToProps(state) {
  return {
    canceledAppts: state.screens.scheduler.canceledAppts,
    wsConnected: state.application.wsConnected,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ fetchCanceledAppointments, deleteEvent }, dispatch),
  };
}

export default memo(connect(mapStateToProps, mapDispatchToProps)(CancelledAppointments));
